import React from "react";
import { withRouter } from "react-router-dom";
import { useNavigate } from "react-router";
import { addDash } from "../../_helpers";

const CustomBreadCrumb = ({ location, courseHistory }) => {

  // Get route path segments
  const navigate=useNavigate();
  const [urlData, setUrlData] = React.useState([]);

  // const getSegments = (location) => {
  //   return location.pathname
  //     .split("/")
  //     .splice(1)
  //     .map((segment) => segment.replace(/\d|-/g, " "));
  // };

  const redirectToBack = (val, position) => {
    // console.log(urlData)
 
    const props = position && position == 1 ? { category: urlData[0], subCategory: urlData[1] } : { category: urlData[0] }; 
    navigate({
      pathname: "/courses",
      state: props,
    });
    
  };

  React.useEffect(() => {
    if (courseHistory) {
      setUrlData(courseHistory);
    }
  }, [courseHistory]);

  return (
    <div className="custom-breadcrumb">
      <ul>
        {urlData.filter(n => n).map((segment, index) => (
          <li onClick={() => redirectToBack(segment, index)} key={index}>
            {segment}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CustomBreadCrumb;
